<template>
    <SocialAuthBtn
        id="facebook-login-btn"
        :img="logo"
        :label="$t('shared.loginModule.socialAuthBtns.continueWithFacebook')"
        color="#3b63be"
        class="facebook-btn"
        @click="fLogIn"
        :tiny="tiny"
    />
</template>

<script>
import SocialAuthBtn from './SocialAuthBtn';
import FacebookFlow from '~/utils/socialAuth/FacebookFlow';
import FacebookLogo from '~/assets/img/FacebookLogo.png';

export default {
    name: 'FacebookLoginBtn',
    components: { SocialAuthBtn },
    props: {
        redirectPath: String,
        tiny: Boolean,
    },
    data: () => ({
        logo: FacebookLogo,
    }),
    methods: {
        async fLogIn() {
            let queryObject = {
                redirectUrl: this.$interfaces.logInModule.getRedirect() || this.$route.path,
            };

            FacebookFlow.startAuthFlow(this.redirectPath, queryObject, this.$route.query || {});
        },
    },
};
</script>

<style>
.facebook-btn > img {
    margin: -4px 30px 0 10px !important;
    height: 24px !important;
    object-fit: scale-down;
}
</style>
